module.exports = __webpack_public_path__ + "img/Facebook_black.f53c8acb.svg";